var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadmore"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('more')}}},[(!_vm.isLoading)?_c('span',[_vm._v("Load More")]):_c('LoadingWheel')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }